import styles from './RadioButton.module.css';
import { classList } from '../../helpers/classList';
import { FieldError } from '../FieldError';

export interface RadioButtonProps {
  id?: string;
  name?: string;
  className?: string;
  checked: boolean;
  disabled?: boolean;
  value: string | number | readonly string[];
  text: string;
  error?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

export const RadioButton = (props: RadioButtonProps) => {
  return (
    <div className={classList(styles.container, props.className)}>
      <input
        type='radio'
        id={props.id}
        name={props.name}
        className={styles.radio}
        value={props.value}
        checked={props.checked}
        disabled={props.disabled}
        onChange={props.onChange}
        onBlur={props.onBlur}
      />
      <label htmlFor={props.id} className={styles.label}>
        {props.text}
      </label>
      {props.error && <FieldError>{props.error}</FieldError>}
    </div>
  );
};
